import { ADD_RECENT_SEARCH, DISMISS_COACHMARK } from './actions';
import { djb2Hash } from '../../utils/djb2Hash';

const initialState = {
  recent: [], // Array of { searchKey, params, savedOffers }
  coachmarkDismissed: false,
};

function getSearchKey(params) {
  const { startDate, endDate, fromLocationCode, toLocationCode, age } = params || {};
  return djb2Hash([
    startDate || '',
    endDate || '',
    fromLocationCode || '',
    toLocationCode || '',
    age || ''
  ].join('|')).toString();
}

export default function recentSearchesReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_RECENT_SEARCH: {
      const { params, savedOffers } = action.payload;
      const searchKey = getSearchKey(params);
      // Remove if already exists
      const filtered = state.recent.filter(r => r.searchKey !== searchKey);
      // Add new at top
      filtered.unshift({ searchKey, params, savedOffers });
      // Keep only 5
      return {
        ...state,
        recent: filtered.slice(0, 5),
      };
    }
    case DISMISS_COACHMARK:
      return {
        ...state,
        coachmarkDismissed: true,
      };
    default:
      return state;
  }
}
